import noop from 'lodash/noop';
import React from 'react';
import { UIContextType } from '@repo/ui/src/modules/UI';

export const UIContext = React.createContext<UIContextType>({
  openModalsMap: new Map(),
  openModalIds: [],
  pushModal: noop,
  closeModal: noop,
  enableID: noop,
  disableID: noop,
  addListener: noop,
  removeListener: noop,
});
